export default {
    documentStatus: {
        complete: 'Completo',
        pending: 'Pending',
        error: 'Error',
    },
    containerStatus: {
        inTransit: 'In Transito',
        delivered: 'Consegnato',
        delayed: 'In Ritardo',
        atPort: 'Al Porto',
    },
    riskLevel: {
        low: 'Basso',
        medium: 'Medio',
        high: 'Alto',
        critical: 'Critico',
    },
    documentType: {
        billOfLading: 'Bill of Lading',
        invoice: 'Fattura Commerciale',
        phytosanitaryCertificate: 'Certificato Fitosanitario',
        movementCertificate: 'Certificato EUR.1',
        packingList: 'Lista di Imballaggio',
        fumigationCertificate: 'Certificato di Fumigazione',
        sadIcm: 'SAD/ICM',
        coo: 'Certificato di Origine',
        unknown: 'Documento Sconosciuto',
    },
    roles: {
        authority: 'Autorità',
        freightForwarder: 'Freight Forwarder',
        sales: 'Sales',
        spedizioniere: 'Spedizioniere',
        dogana: 'Dogana',
        vettoreMarittimo: 'Vettore marittimo',
        trasportoTerrestre: 'Trasporto terrestre',
        portoImbarco: 'Porto imbarco',
        portoSbarco: 'Porto di sbarco',
        staffAeroporto: 'Staff aeroporto',
        armatore: 'Armatore',
    },
    status: {
        active: 'Attivo',
        pending: 'In Attesa',
        rejected: 'Rifiutato',
        suspended: 'Sospeso',
        inactive: 'Inattivo',
        accepted: 'Accettato',
        modified: 'In attesa di risposta',
        confirmed: 'Confermato',
        cancelled: 'Cancellato',
    },
    teamRoles: {
        admin: 'Admin',
        editor: 'Editor',
        viewer: 'Viewer',
    },
};

